import { Injectable } from "@angular/core";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);

@Injectable({
  providedIn: "root",
})
export class DateTimeService {
  isTimeWithinCurrentDay(timeToCheck: string): boolean {
    const now = dayjs();
    const startOfDay = now.startOf("day");
    const endOfDay = now.endOf("day");
    const parsedTime = dayjs(timeToCheck);
    return parsedTime.isBetween(startOfDay, endOfDay);
  }
  getCurrentTimestamp(date?: string | Date): Date {
    return dayjs(date).toDate();
  }

  getShortDate(date?: string | Date): string {
    return dayjs(date).format("MMM DD, YYYY");
  }
}
